import { render, staticRenderFns } from "./general-info-container.vue?vue&type=template&id=d2e4a36e&scoped=true&lang=pug"
import script from "./general-info-container.js?vue&type=script&lang=js&external"
export * from "./general-info-container.js?vue&type=script&lang=js&external"
import style0 from "./general-info-container.vue?vue&type=style&index=0&id=d2e4a36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e4a36e",
  null
  
)

export default component.exports